import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SettingsService } from 'src/app/shared/services/settings.service';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';

@Component({
    selector: 'app-import-export',
    templateUrl: './import-export.component.html',
    standalone: true,
    imports: [MatAnchor, MatIcon]
})
export class ImportExportComponent {
  loading = false;
  constructor(
    private settingsService: SettingsService,
    @Inject(DOCUMENT) private document: Document,
    private toastr: ToastrService
  ) {}
  exportProducts() {
    this.loading = true;
    this.settingsService.exportProducts().subscribe(
      (response: any) => {
        const blob = new Blob([response], { type: 'application/xlsx' });
        const url = window.URL.createObjectURL(blob);
        const a = this.document.createElement('a');
        this.document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = 'Product-Export.xlsx';
        a.click();
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  handleImportFileSelected(eventTarget: any) {
    const file = eventTarget.files[0];
    this.settingsService.importProducts(file).subscribe(
      (response) => {
        let explanation = '';
        if (response.categories) {
          explanation += `${response.categories.created} categories created, ${response.categories.updated} categories updated. `;
        }
        if (response.products) {
          explanation += `${response.products.created} products created, ${response.products.updated} products updated. `;
        }
        if (response.items) {
          explanation += `${response.items.created} items created, ${response.items.updated} items updated. `;
        }
        this.toastr.success('Products imported successfully', explanation);
      },
      (error) => {
        this.toastr.error('Error importing products', 'Please contact support');
        console.log(error);
      }
    );
  }
}
